import axios from 'axios';
import Environment from '../../utils/Environment';

interface GroupData {
  [groupName: string]: string[];
}

const fallbackGroups: GroupData = {
  "Shipping": ["Door Clean Up"],
  "Location": ["Banana Sequencing"]
};

const getServiceGroups = async (
  dcCode: string,
  setIsLoading: (loading: boolean) => void,
  setData: (data: GroupData) => void
) => {
  setIsLoading(true);
  try {
    const baseURL = Environment.getGroupDropDownAPI();

    if (!baseURL || !dcCode) {
      setData(fallbackGroups);
      return;
    }

    const apiURL = `${baseURL}?dcCode=${encodeURIComponent(dcCode)}`;
    const response = await axios.get(apiURL);
    const apiData: GroupData = response.data;

    setData({
      ...apiData,
      Location: ["Banana Sequencing"]
    });
  } catch (err: any) {
    console.error('Error fetching group dropdown data:', err);
    setData(fallbackGroups);
  } finally {
    setIsLoading(false);
  }
};

export default getServiceGroups;